import * as React from "react";
import {
  Box,
  Grid,
  Paper,
  Card,
  CardContent,
  Typography,
  CardActionArea,
} from "@mui/material";
import Api from "../../../API/API";
import cookie from "../../../API/cookie";
import { useEffect } from "react";
import { useState } from "react";

import {
  buildCmdFromRecipe,
  calcTotalSecondsFromCmd,
  buildTimelineFromCmd,
  buildPersonal,
} from "./stimRecipes";

import AdminStimulusPage from "./StimulusPage/AdminStimulusPage";
import UserStimulusPage from "./StimulusPage/UserStimulusPage";
import UserStimulusManagePage from "./StimulusPage/UserStimulusManagePage";
import StimulusManagerOnlyPage from "./StimulusManagerOnlyPage";
import StimulusRecipeManagePage from "./StimulusRecipeManagePage";
import GroupManagePage from "./StimulusPage/GroupManagePage";

// Debounce
function debounce(fn, delay) {
  let timer = null;

  return (...args) => {
    // delay 동안에는 추가 호출 무시
    if (timer) return;

    // 첫 클릭은 바로 실행
    fn(...args);

    // delay 동안 다시 못 누르게 잠금
    timer = setTimeout(() => {
      timer = null; // delay 지나면 다시 눌러도 실행 가능
    }, delay);
  };
}


var bluetoothService = null;
const WRITE_UUID = "6e400002-b5a3-f393-e0a9-e50e24dcca9e";
var defaultValue;

let user_id = cookie.getCookie("userAccount")
  ? cookie.getCookie("userAccount")
  : "";
var api_token = cookie.getCookie("accessToken");

if (user_id) {
  defaultValue = { key: api_token };
}



function ExperimentMachineListPageMiddle2(props) {
  const machine = props.machine;

  // Experiments ID
  const [protoExpId, setProtoExpId] = useState(null);
  const [serverRemainingSec, setServerRemainingSec] = useState(null);
  const [isStimRunning, setIsStimRunning] = useState(false);

  const [protocolExpId, setProtocolExpId] = useState(null);
  const protocolExpIdRef = React.useRef(null);


  const isStaffRef = React.useRef(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isStaff, setIsStaff] = useState(false);
  const [adminView, setAdminView] = useState("main");

  const [stim, setstim] = React.useState("자극 대기중");
  const [stimTime, setstimTime] = React.useState(0);
  const [machineStatus, setmachineStatus] = React.useState(undefined);
  const [updateStatusTime, setupdateStatusTime] = React.useState(
    () => new Date()
  );

  const [sessionTotal, setSessionTotal] = React.useState(null);
  const remainingTimeSec =
    typeof serverRemainingSec === "number"
      ? Math.max(serverRemainingSec, 0)
      : (sessionTotal != null ? Math.max(sessionTotal - stimTime, 0) : stimTime);    
  const isRunningRef = React.useRef(false);
  const statusRef = React.useRef(machineStatus);
  const timeRef = React.useRef(updateStatusTime);
  const stimTimeRef = React.useRef(stimTime);
  const lastStimParamsRef = React.useRef({
    amplitude: 0,
    width: 0,
    interval: 0,
  });
  const currentTimelineRef = React.useRef([]);
  const lastUploadedTimeRef = React.useRef(0);
  const [stimValues, setStimValues] = useState(["", "", "", "", "", ""]);

  // Load Recipes
  const [savedRecipes, setSavedRecipes] = useState([]);
  const [recipesLoading, setRecipesLoading] = useState(false);
  const [recipesError, setRecipesError] = useState(null);

  const deviceRef = React.useRef(null);       // BluetoothDevice 보관
  const serviceUuidRef = React.useRef(null);  // service UUID 보관
  const reconnectingRef = React.useRef(false); // 중복 재연결 방지

  
  useEffect(() => {
    isStaffRef.current = isStaff;
  }, [isStaff]);


useEffect(() => {
  if (!defaultValue) return;
  if (!protoExpId) return;
  if (!isStimRunning) {
    setServerRemainingSec(null);
    return;
  }

  let alive = true;

  const fetchTimer = async () => {
    try {
      const res = await Api.getProtocolExpStimulusTimer(protoExpId, defaultValue);
      if (!alive) return;

      const data = res?.data;
      if (data && typeof data.remaining_sec === "number") {
        setServerRemainingSec(data.remaining_sec);
      } else {
        setServerRemainingSec(null);
      }
    } catch (e) {
      // 실패해도 로컬 fallback 유지
    }
  };

  fetchTimer();
  const iv = setInterval(fetchTimer, 1000);

  return () => {
    alive = false;
    clearInterval(iv);
  };
}, [protoExpId, isStimRunning, defaultValue]);

  useEffect(() => {
    protocolExpIdRef.current = protocolExpId;
  }, [protocolExpId]);

  class CancelError extends Error {
    constructor() {
      super("CANCELLED");
      this.name = "CancelError";
    }
  }

  // Check firmware verison
  const firmwareRevRef = React.useRef(null);

  useEffect(() => {
    firmwareRevRef.current = machine?._fwRev ?? null;
    if (firmwareRevRef.current) {
      console.log("[BLE] cached firmwareRevision:", firmwareRevRef.current);
    }
  }, [machine]);


  // DB Log Upload Timeline
  function prepareTimelineForCmd(cmd) {
    const timeline = buildTimelineFromCmd(cmd);
    currentTimelineRef.current = timeline;

    if (timeline && timeline.length > 0) {
      const first = timeline[0];
      lastStimParamsRef.current = {
        amplitude: first.amp ?? 0,
        width: first.width ?? 0,
        interval: first.duration ?? 0,
      };
    } else {
      lastStimParamsRef.current = {
        amplitude: 0,
        width: 0,
        interval: 0,
      };
    }
    lastUploadedTimeRef.current = 0;
  }

  const handleChangeStimValue = (index) => (e) => {
    setStimValues((prev) => {
      const copy = [...prev];
      copy[index] = e.target.value;
      return copy;
    });
  };

  // 현재 실행 중 run 식별자 (전환 시 레이스 방지)
  const runIdRef = React.useRef(0);

  const cancelRef = React.useRef({
    promise: new Promise(() => {}),
    cancel: () => {},
  });

  // ---------- GATT Serialization
  const gattQueueRef = React.useRef(Promise.resolve());
  const charRef = React.useRef(null);

  // GATT serialization
  function runGatt(op) {
    const next = gattQueueRef.current.then(op);
    gattQueueRef.current = next
      .catch((e) => {
        console.error(
          "[BLE] runGatt error, keep chain:",
          e?.message || e
        );
      })
      .finally(() => {});
    return next;
  }

  // Get GATT characteristic
  async function getWriteChar() {

    if (!machine && !bluetoothService) {
      if (isStaffRef.current) return null;
      throw new Error("No BLE service");
    }

    if (!charRef.current) {
      await runGatt(async () => {
        if (!charRef.current) {
          console.log("[BLE] getCharacteristic");
          if (!bluetoothService) {
            bluetoothService = machine;
          }
          charRef.current = await bluetoothService.getCharacteristic(WRITE_UUID);
        }
      });
    }
    return charRef.current;
  }

  async function attemptReconnect() {
    if (reconnectingRef.current) {
      console.log("[BLE] already reconnecting, skip");
      return;
    }

    const device =
      (bluetoothService && bluetoothService.device) ||
      deviceRef.current ||
      (machine && machine.device);

    const serviceUuid =
      (bluetoothService && bluetoothService.uuid) ||
      serviceUuidRef.current ||
      (machine && machine.uuid);

    if (!device || !serviceUuid) {
      console.warn("[BLE] No device or service UUID to reconnect");
      return;
    }

    reconnectingRef.current = true;
    setmachineStatus("reconnecting");
    setstim("기기 재연결 시도 중…");

    try {
      console.log("[BLE] trying to reconnect...");

      const server = device.gatt.connected
        ? device.gatt
        : await device.gatt.connect();

      const newService = await server.getPrimaryService(serviceUuid);

      bluetoothService = newService;
      deviceRef.current = device;
      serviceUuidRef.current = serviceUuid;

      charRef.current = null;
      await getWriteChar();

      if (typeof props.onMachineReconnect === "function") {
        try {
          props.onMachineReconnect(newService);
        } catch (err) {
          console.error("[BLE] onMachineReconnect callback error", err);
        }
      }

      if (isRunningRef.current) {
        setmachineStatus("running");
        setstim("자극 진행중");
      } else {
        setmachineStatus("off");
        setstim("자극 대기중");
      }
      console.log("[BLE] reconnect success");
    } catch (e) {
      console.log(isStaffRef.current);
      
      console.error("[BLE] reconnect failed", e);
      setmachineStatus("off");
      alert("기기와의 연결이 끊어졌습니다. 다시 연결을 시도해주세요.");

      if (!isStaffRef.current) window.location.reload();
    } finally {
      reconnectingRef.current = false;
    }
  }

  const BLE_MAX_BYTES = 180;
  const FW_NO_CHUNK_HASH = "1c6d9cf"; // Exception Firmware version

  function shouldSkipChunking() {
    const fw = String(firmwareRevRef.current ?? "").trim();
    return fw.includes(FW_NO_CHUNK_HASH);
  }

  function encodeBleChunks(cmd, maxBytes = BLE_MAX_BYTES) {
    const normalized = String(cmd ?? "").replace(/\n+$/, "") + "\n";

    const encoder = new TextEncoder();
    const bytes = encoder.encode(normalized);

    if (shouldSkipChunking()) {
      return { normalized, chunks: [bytes], skipChunking: true, totalBytes: bytes.length };
    }

    const chunks = [];
    for (let i = 0; i < bytes.length; i += maxBytes) {
      chunks.push(bytes.slice(i, i + maxBytes));
    }

    return { normalized, chunks, skipChunking: false, totalBytes: bytes.length };
  }

  
  async function writeOnce(characteristic, uint8array, label = "cmd") {
    await characteristic.writeValueWithoutResponse(uint8array);
  }

  async function writeCmds(cmds) {
    const arr = Array.isArray(cmds) ? cmds : [cmds];
    const decoder = new TextDecoder();

    return runGatt(async () => {
      const ch = await getWriteChar();

      if (!ch) {
        console.warn("[BLE] skip write: admin mode & not paired", arr);
        return;
      }

      for (const c of arr) {
        const { normalized, chunks, skipChunking, totalBytes } = encodeBleChunks(c, BLE_MAX_BYTES);

        /*
        console.log(
          "[BLE] write (normalized):",
          JSON.stringify(normalized),
          "fw=",
          JSON.stringify(String(firmwareRevRef.current ?? "").trim()),
          "skipChunking=",
          skipChunking,
          "totalBytes=",
          totalBytes,
          "chunks=",
          chunks.length
        );
        */

        for (let i = 0; i < chunks.length; i++) {
          const chunkBytes = chunks[i];
          const chunkText = decoder.decode(chunkBytes);
        
          console.log(
            `[BLE] chunk ${i + 1}/${chunks.length} bytes=${chunkBytes.length} ` +
              `text=${JSON.stringify(chunkText)} `
          );
        
          await writeOnce(ch, chunkBytes, `cmd_chunk_${i + 1}`);
        }
      }
    });
  }
  
  const formatTime = (totalSec) => {
    const mm = String(Math.floor(totalSec / 60)).padStart(2, "0");
    const ss = String(totalSec % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const resetCancelToken = () => {
    let cancel;
    const promise = new Promise((_, reject) => {
      cancel = reject;
    });
  
    promise.catch((e) => {
      if (e && e.name !== "CancelError") {
        console.error("[cancelToken] unexpected error:", e);
      }
    });
  
    cancelRef.current.promise = promise;
    cancelRef.current.cancel = cancel;
  };

  const delay = (sec) =>
    new Promise((resolve) => setTimeout(resolve, sec * 1000));

  useEffect(() => {
    statusRef.current = machineStatus;
  }, [machineStatus]);
  useEffect(() => {
    timeRef.current = updateStatusTime;
  }, [updateStatusTime]);
  useEffect(() => {
    stimTimeRef.current = stimTime;
  }, [stimTime]);

  useEffect(() => {
  const handleNavigate = (e) => {
    const view = e.detail?.view;

    if (view === "userManage") {
      setAdminView("userManage");
    } else if (view === "stimManager") {
      setAdminView("stimManager");
    } else if (view === "main") {
      setAdminView("main");
    } else if (view === "recipeManage"){
      setAdminView("recipeManage");
    } else if (view === "groupManage"){
      setAdminView("groupManage");
    }
  };

  const handleReconnect = () => {
    // 연결 끊긴 상태에서만 쓰고 싶으면 여기서 상태 보고 조건 걸어도 됨
    attemptReconnect();
  };

  window.addEventListener("stim:navigate", handleNavigate);
  window.addEventListener("stim:reconnect", handleReconnect);

  return () => {
    window.removeEventListener("stim:navigate", handleNavigate);
    window.removeEventListener("stim:reconnect", handleReconnect);
  };
}, []);

  
  useEffect(() => {
    if (!machine) return;

    const device = machine.device;
    if (device) {
      deviceRef.current = device;
      serviceUuidRef.current = machine.uuid;
    }

    // GATT 초기화
    (async () => {
      try {
        console.log("[BLE] Initializing GATT characteristic...");
        await getWriteChar();
        console.log("[BLE] GATT characteristic ready");
      } catch (e) {
        console.error("[BLE] Failed to init GATT characteristic", e);
      }
    })();

    // disconnect 이벤트 리스너 등록
    const handleDisconnect = () => {
      console.warn("[BLE] gattserverdisconnected");
      // 기존 캐시 초기화
      charRef.current = null;
      bluetoothService = null;
      // 자동 재연결 시도
      attemptReconnect();
    };

    if (device) {
      device.addEventListener("gattserverdisconnected", handleDisconnect);
    }

    // cleanup
    return () => {
      if (device) {
        device.removeEventListener("gattserverdisconnected", handleDisconnect);
      }
    };
  }, [machine]);  


useEffect(() => {
  const prevOverflow = document.body.style.overflow;

  const getData = async () => {
    try {
      const fw = String(firmwareRevRef.current ?? "").trim() || null;
      const infoBody = await Api.getAPI_ExperimentSubCreate(user_id, fw);
      const newId = Number(infoBody?.data?.id);

      if (Number.isFinite(newId)) {
        setProtocolExpId(newId);
        protocolExpIdRef.current = newId;

        setProtoExpId(newId);
      } else {
        console.warn("[API] invalid proto_exp_id from server:", infoBody?.data?.id);
      }
  }catch (e) {
      console.error("[API] getAPI_ExperimentSubCreate error", e);
    }
  };
  getData();

  return () => {
    document.body.style.overflow = prevOverflow || "auto";
  };
}, []);

  useEffect(() => {
    const tick = setInterval(() => {
      if (isRunningRef.current) {
        setstimTime((prev) => prev + 1);
      }
    }, 1000);

    return () => clearInterval(tick);
  }, []);

  // update stimulus log every 10sec
  useEffect(() => {
    if (!isRunningRef.current) return;
    if (stimTime <= 0) return;
  
    const timeline = currentTimelineRef.current || [];
    const t = stimTime;
  
    let currentSeg = null;
    for (const seg of timeline) {
      if (t > seg.start && t <= seg.end) {
        currentSeg = seg;
        break;
      }
    }
  
    if (currentSeg) {
      lastStimParamsRef.current = {
        amplitude: currentSeg.amp ?? 0,
        width: currentSeg.width ?? 0,
        interval: currentSeg.duration ?? 0,
      };
    } else {
      lastStimParamsRef.current = {
        amplitude: 0,
        width: 0,
        interval: 0,
      };
    }
  
    if (stimTime % 5 !== 0) return;
  
    if (lastUploadedTimeRef.current === stimTime) return;
    lastUploadedTimeRef.current = stimTime;
  
    const { amplitude, width, interval } = lastStimParamsRef.current || {};
  
    try {
      uploadStimulus(
        amplitude ?? 0,
        width ?? 0,
        interval ?? 0,
        stimTime
      );
    } catch (e) {
      console.error("[Timer] period uploadStimulus error", e);
    }
  }, [stimTime]);

  // Load Recipes
  useEffect(() => {
    if (!defaultValue) return; // 토큰 없으면 스킵

    const fetchRecipes = async () => {
      setRecipesLoading(true);
      setRecipesError(null);
      try {
        const res = await Api.getRecipeList(defaultValue);
        // 백엔드 응답이 res.data 형태라고 가정
        // 예: res.data = [{ id, name, description, recipe }, ...]
        if (res && res.data) {
          setSavedRecipes(res.data);
        } else {
          setSavedRecipes([]);
        }
      } catch (e) {
        console.error("[API] getRecipeList error", e);
        setRecipesError("자극 레시피를 불러오지 못했습니다.");
        setSavedRecipes([]);
      } finally {
        setRecipesLoading(false);
      }
    };

    fetchRecipes();
  }, []);

  //Load User status
  useEffect(() => {
    if (!api_token) return;

    const fetchUser = async () => {
      try {
        const res = await Api.getUserData(api_token);
        if (res && res.data) {
          setCurrentUser(res.data);
          setIsStaff(!!res.data.is_staff);
        }
      } catch (e) {
        console.error("[API] getUserData error", e);
      }
    };

    fetchUser();
  }, []);


  async function ensureProtocolExpId() {
    if (Number.isFinite(protocolExpIdRef.current)) return protocolExpIdRef.current;

    const infoBody = await Api.getAPI_ExperimentSubCreate(user_id);
    const newId = Number(infoBody?.data?.id);

    if (Number.isFinite(newId)) {
      setProtocolExpId(newId);
      protocolExpIdRef.current = newId;

      setProtoExpId(newId);

      return newId;
    }

    return null;
  }

  async function switchToNewRun(startRunner) {
    // 1) 현재 실행 취소
    try {
      cancelRef.current.cancel(new CancelError());
    } catch {}
    // 2) runId 증가 (이전 finally 가드)
    runIdRef.current += 1;
    const myRunId = runIdRef.current;
    
    // 새 실행 준비
    resetCancelToken();
    isRunningRef.current = true;
    
    setstimTime(0);
    await startRunner(myRunId);
  }

  function AddStimulus(cmd, stimulusRecipeId = null) {
    const myRunIdAtStart = runIdRef.current;

    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const pid = await ensureProtocolExpId();
          if (!pid) {
            alert("실험 세션 ID(proto_exp_id)를 만들지 못했습니다. 잠시 후 다시 시도해주세요.");
            return;
          }

          // BLE write
          await writeCmds(["919|1"]);
          await writeCmds([cmd]);

          if (pid && defaultValue) {
            try {
              await Api.startProtocolExpStimulusTimer(pid, defaultValue, stimulusRecipeId);
            } catch (e) {
              console.error("[Timer] startProtocolExpStimulusTimer error", e);
            }
          }

          setmachineStatus("running");
          setIsStimRunning(true);
          setupdateStatusTime(new Date());
          setstim("자극 진행중");

          if (runIdRef.current !== myRunIdAtStart) return resolve();
          if (!isRunningRef.current) return reject(new CancelError());
          resolve();
        } catch (e) {
          reject(e);
        }
      })();
    });
  }

  const runSavedRecipe = (recipeEntity) => {
    // recipeEntity: { id, name, description, recipe } 가정
    const label = recipeEntity.name || `자극 #${recipeEntity.id}`;

    return startRecipe(label, async () => {
      let recipeJson = recipeEntity.recipe;

      // 백엔드에서 recipe를 문자열로 주면 파싱
      if (typeof recipeJson === "string") {
        try {
          recipeJson = JSON.parse(recipeJson);
        } catch (e) {
          console.error("Invalid recipe JSON string from server:", e);
          alert("서버에서 받은 자극 설정이 잘못되었습니다.");
          return;
        }
      }

      // recipeJson 형식은 buildStimJsonFromBlocks 결과와 동일하다고 가정
      // { blocks: [...], block_count: n }
      const cmd = buildCmdFromRecipe(recipeJson);

      setSessionTotal(calcTotalSecondsFromCmd(cmd));
      prepareTimelineForCmd(cmd);

      await AddStimulus(cmd, recipeEntity.id);
    });
  };

  function EndStimulus() {
    console.log("[CLICK->EndStimulus]");
    try {
      isRunningRef.current = false;
      
      const end_ = "921 1";
      writeCmds(end_)
        .then(() => {
          setstim("자극 종료");
          setmachineStatus("off");
          setstimTime(0);
          setIsStimRunning(false);
          setServerRemainingSec(null);
          setSessionTotal(null);
          setupdateStatusTime(new Date());

          currentTimelineRef.current = [];
          lastStimParamsRef.current = {
            amplitude: 0,
            width: 0,
            interval: 0,
          };
          lastUploadedTimeRef.current = 0;
          reconnectingRef.current = false;
        })
        .catch((e) => {
          console.error("[BLE] EndStimulus error", e);
          alert("기기 연결이 중단되었습니다. 페이지를 새로고침 해주세요.");
        });
    } catch {
      alert("기기 연결이 중단되었습니다. 페이지를 새로고침 해주세요.");
    }
  }

  function EndStimulus_old() {
    console.log("[CLICK->EndStimulus]");
    try {
      isRunningRef.current = false;
      
      const end_ = "910 1";
      writeCmds(end_)
        .then(() => {
          setstim("자극 종료");
          setmachineStatus("off");
          setstimTime(0);
          setSessionTotal(null);
          setupdateStatusTime(new Date());

          currentTimelineRef.current = [];
          lastStimParamsRef.current = {
            amplitude: 0,
            width: 0,
            interval: 0,
          };
          lastUploadedTimeRef.current = 0;
          reconnectingRef.current = false;
        })
        .catch((e) => {
          console.error("[BLE] EndStimulus error", e);
          alert("기기 연결이 중단되었습니다. 페이지를 새로고침 해주세요.");
        });
    } catch {
      alert("기기 연결이 중단되었습니다. 페이지를 새로고침 해주세요.");
    }
  }


  async function uploadStimulus(amplitude, width, duration, end) {
    const pid = protocolExpIdRef.current;

    if (!Number.isFinite(pid)) {
      console.warn("[uploadStimulus] skip: proto_exp_id not ready");
      return;
    }
    if (!defaultValue) {
      console.warn("[uploadStimulus] skip: no token");
      return;
    }

    const obj = {
      proto_exp_id: pid,
      intensity: Math.trunc(Number(width) || 0),
      interval: Math.trunc(Number(duration) || 0),
      height: Math.trunc(Number(amplitude) || 0),
      long: 0,
      time: Math.trunc(Number(end) || 0),
    };

    try {
      await Api.getPostStimulus(obj, defaultValue);
    } catch (e) {
      console.error("[API] getPostStimulus error", e);
    }
  }

  const startRecipe =
    (label, bodyFn) =>
    () => {
      console.log("[BTN]", label);
      setstim(`(${label}) 전환 중…`);
      switchToNewRun(async (myRunId) => {
        try {
          await bodyFn();
        } catch (e) {
          if (e?.name !== "CancelError") console.error(e);
        }
      });
    };

  const recipe_personal = startRecipe("자극", async () => {
    const cmd = await buildPersonal(defaultValue);
    setSessionTotal(calcTotalSecondsFromCmd(cmd));
    prepareTimelineForCmd(cmd);
    await AddStimulus(cmd);
  });



  //Debounce
  /*
  const recipe_personal_debounceRef = React.useRef(null);
  if (!recipe_personal_debounceRef.current) {
    recipe_personal_debounceRef.current = debounce(recipe_personal, 5000);
  }

  const recipe_personal_temp_debounceRef = React.useRef(null);
  if (!recipe_personal_temp_debounceRef.current) {
    recipe_personal_temp_debounceRef.current = debounce(recipe_personal_temp, 5000);
  }

  const recipe_personal_temp2_debounceRef = React.useRef(null);
  if (!recipe_personal_temp2_debounceRef.current) {
    recipe_personal_temp2_debounceRef.current = debounce(recipe_personal_temp2, 5000);
  }
  */

  const CardBtn = ({ onClick, children }) => (
    <Card sx={{ width: "90%", backgroundColor: "#393939" }}>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Typography
            sx={{
              fontSize: 20,
              fontFamily: "GmarketSansMedium",
              textAlign: "center",
            }}
            color="white"
          >
            {children}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );

  const goStimulusManager = () => {
    if (typeof props?.onOpenStimulusManager === "function") {
      props.onOpenStimulusManager();
      return;
    }
    alert("자극관리 페이지로 이동 핸들러가 연결되지 않았습니다.");
  };

  if (isStaff) {
      if (adminView === "userManage") {
        return (
          <UserStimulusManagePage
            onBack={() => setAdminView("main")}
          />
        );
      }

      if (adminView === "stimManager") {
        return (
          <StimulusManagerOnlyPage
            onBack={() => setAdminView("main")}
            onWriteCmd={writeCmds}
          />
        );
      }

      if (adminView === "recipeManage") {
        return <StimulusRecipeManagePage onBack={() => setAdminView("main")} />;
      }
      
      if(adminView === "groupManage"){
        return (
          <GroupManagePage  onBack={() => setAdminView("main")} />
        );
      }
    return (
      <AdminStimulusPage
        stim={stim}
        remainingTimeSec={remainingTimeSec}
        recipesLoading={recipesLoading}
        recipesError={recipesError}
        savedRecipes={savedRecipes}
        runSavedRecipe={runSavedRecipe}
        goStimulusManager={goStimulusManager}
        goUserManage={() => setAdminView("userManage")}
        formatTime={formatTime}
        onReconnect={attemptReconnect}
      />
    );
  }
  else {
    return (
      <UserStimulusPage
        stim={stim}
        recipePersonal={recipe_personal}
        endStimulus={EndStimulus}
        remainingTimeSec={remainingTimeSec}
        formatTime={formatTime}
      />
    );
  }
}

export default ExperimentMachineListPageMiddle2;